var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedSaved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 3.09998C15.13 3.09998 13.51 3.97998 12.5 5.32998C11.49 3.97998 9.87 3.09998 8.06 3.09998C4.99 3.09998 2.5 5.59998 2.5 8.68998C2.5 9.87998 2.69 10.98 3.02 12C4.6 17 9.47 19.99 11.88 20.81C12.22 20.93 12.78 20.93 13.12 20.81C15.53 19.99 20.4 17 21.98 12C22.31 10.98 22.5 9.87998 22.5 8.68998C22.5 5.59998 20.01 3.09998 16.94 3.09998Z",
    fill: "#F06565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedSaved);
export default __webpack_public_path__ + "static/media/selected-saved.1ea951583979e3123a4d8e346c6b96b6.svg";
export { ForwardRef as ReactComponent };